import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import {
  DashboardServiceServiceProxy,
} from "@shared/service-proxies/service-proxies";
import { ExportService } from "@shared/export/export.service";
import { Title } from "@angular/platform-browser";
import { Platform } from '@ionic/angular';

@Component({
  selector: "app-dashbaord",
  templateUrl: "./dashboard.page.html",
  styleUrls: ["./dashboard.page.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class DashboardPage implements OnInit {

  constructor(
    private dashboardService: DashboardServiceServiceProxy,
    private exportService: ExportService,
    private titleService: Title,
    public platform: Platform
  ) {}
  ngOnInit() {
    this.titleService.setTitle("OACI - Dashboard");
  }

  setupDataSets() {}

  export() {
    this.dashboardService.export().subscribe((fileResponse) => {
      this.exportService.saveFile(fileResponse, "Certifications");
    });
  }

  print() {

    window.print();

  }
}
